// src/components/AGTUps/services/AGTUps-product-services/consultService.js

import { api } from './config';

const consultService = {
  configExpertPanel: async (data) => {
    try {
      const response = await api.post('/consult/config-panel', data);
      return response.data;
    } catch (error) {
      console.error('[consultService] Error configurando panel de expertos:', error);
      throw new Error(error.response?.data?.error || 'Error configurando panel de expertos');
    }
  },

  scheduleMeeting: async (consultationId, desiredTime) => {
    try {
      const response = await api.post('/consult/schedule-meeting', { consultationId, desiredTime });
      return response.data;
    } catch (error) {
      console.error('[consultService] Error agendando reunión:', error);
      throw new Error(error.response?.data?.error || 'Error agendando reunión');
    }
  },

  getConsultation: async (consultationId) => {
    try {
      const encodedId = encodeURIComponent(consultationId);
      const response = await api.get(`/consult/${encodedId}`);
      return response.data;
    } catch (error) {
      console.error('[consultService] Error obteniendo consulta:', error);
      throw new Error(error.response?.data?.error || 'Error obteniendo consulta');
    }
  },

  addMessage: async (data) => {
    try {
      const response = await api.post('/consult/add-message', data);
      return response.data;
    } catch (error) {
      console.error('[consultService] Error agregando mensaje:', error);
      throw new Error(error.response?.data?.error || 'Error agregando mensaje');
    }
  },

  startConsultation: async (consultationId, userMessage) => {
    try {
      const response = await api.post('/consult/start-consultation', { consultationId, userMessage });
      return response.data;
    } catch (error) {
      console.error('[consultService] Error iniciando consulta (Asistente 1):', error);
      throw new Error(error.response?.data?.error || 'Error iniciando consulta');
    }
  },

  continueConsultation: async (consultationId) => {
    try {
      const response = await api.post('/consult/continue-consultation', { consultationId });
      return response.data;
    } catch (error) {
      console.error('[consultService] Error continuando consulta (Asistente 2):', error);
      throw new Error(error.response?.data?.error || 'Error continuando consulta');
    }
  },

  finishConsultation: async (consultationId) => {
    try {
      const response = await api.post('/consult/finish-consultation', { consultationId });
      return response.data;
    } catch (error) {
      console.error('[consultService] Error finalizando consulta (Asistente 3):', error);
      throw new Error(error.response?.data?.error || 'Error finalizando consulta');
    }
  },

  // Nueva función: Finalizar consulta por timeout
  finishConsultationByTimeout: async (consultationId) => {
    try {
      const response = await api.post('/consult/finish-by-timeout', { consultationId });
      return response.data;
    } catch (error) {
      console.error('[consultService] Error finalizando consulta por timeout:', error);
      throw new Error(error.response?.data?.error || 'Error finalizando consulta por timeout');
    }
  },

  // Nueva función: Verificar disponibilidad de sesión diaria
  checkSessionAvailability: async () => {
    try {
      const response = await api.get('/consult/session-availability');
      return response.data;
    } catch (error) {
      console.error('[consultService] Error verificando disponibilidad:', error);
      throw new Error(error.response?.data?.error || 'Error verificando disponibilidad de sesión');
    }
  },

  getUserConsultations: async () => {
    try {
      const response = await api.get('/consult/recent');
      return response.data;
    } catch (error) {
      console.error('[consultService] Error obteniendo consultas recientes:', error);
      throw new Error(error.response?.data?.error || 'Error obteniendo consultas recientes');
    }
  },

  getConsultationStats: async () => {
    try {
      const response = await api.get('/consult/stats');
      return response.data;
    } catch (error) {
      console.error('[consultService] Error obteniendo estadísticas de consulta:', error);
      throw new Error(error.response?.data?.error || 'Error obteniendo estadísticas de consulta');
    }
  },

  getUpcomingSessions: async () => {
    try {
      const response = await api.get('/consult/sessions');
      return response.data;
    } catch (error) {
      console.error('[consultService] Error obteniendo próximas sesiones:', error);
      throw new Error(error.response?.data?.error || 'Error obteniendo próximas sesiones');
    }
  },
  
  // Nueva función: Obtener consulta específica con su historia
  getConsultationHistory: async (consultationId) => {
    try {
      const response = await api.get(`/consult/history/${consultationId}`);
      return response.data;
    } catch (error) {
      console.error('[consultService] Error obteniendo historial de consulta:', error);
      throw new Error(error.response?.data?.error || 'Error obteniendo historial de consulta');
    }
  }
};

export default consultService;